export enum Paths {
    ROOT = '/',
    SIGN_UP = '/sign-up',
    SIGN_IN = '/sign-in',
    RESET_PASSWORD = '/reset-password',
    MAIN_APP = '/app',
    ONBOARDING = '/app/onboarding',
    DATA_FARMING = '/app/data-farming',
    DATA_FARMING_TABLE = '/app/data-farming-dashboard',
    DASHBOARD = '/app/dashboard',
    DASHBOARD_INVESTOR = '/app/dashboard/investor',
    DASHBOARD_VALIDATOR = '/app/dashboard/validator',
    STAKE = '/app/stake',
    REVIEW_LOAN_APPLICATION = '/app/loan/:id/review',
    LIQUIDITY_PROVIDER = '/app/liquidity-provider',
    LOAN_APPLICATIONS = '/app/loan-applications',
    LENDING_POOLS = '/app/lending-pools-farming',
    LENDING_POOL = '/app/nft-usdc-lending-pool',
    LOANS_HISTORY = '/app/loans/history',
    LOANS = '/app/loans',
    LOAN = '/app/loan/:id',
    ACCOUNTS = '/app/accounts',
    REWARDS = '/app/rewards',
    SETTINGS = '/settings',
    UPDATE_PROFILE = '/settings/profile',
    UPDATE_SECURITY = '/settings/security',
    WALLETS = 'settings/wallets',
    DEMO_SETTINGS = '/app/demo-settings',
}

export enum MasaDashboardPaths {
    ROOT = '/masa',
    USERS = '/masa/users',
    USER = '/masa/user/:id',
    USER_ACCOUNTS = '/masa/user/:id/accounts',
}

export enum AddAccountPaths {
    ADD_ACCOUNT = '/app/add-account',
    ADD_BANK_ACCOUNT = '/app/add-account/bank',
    ADD_CRYPTO_ACCOUNT = '/app/add-account/crypto',
    ADD_COINBASE_ACCOUNT = '/app/add-account/coinbase',
}
